import { Flex, Heading, useBreakpointValue } from "@chakra-ui/react";
import { CategoryNavigation } from "../CategoryNavigation";

function Category({
                    title,
                    tabKey,
                    shouldShowNext,
                    shouldShowPrev,
                    children,
                    categories,
                    CustomHeaderComponent,
                    customHeaderProps,
                    questionnaireId,
                    isPreview
                  }) {
  const currentIndex = categories.findIndex((x) => x === tabKey);
  const formId = `formStep${tabKey}`;
  const containerDisplay = useBreakpointValue({
    base: "block",
    md: "flex"
  });

  return (
    <Flex flexDir="column" blockSize="full">
      {CustomHeaderComponent ?
        <Flex justifyContent="space-between" display={containerDisplay}
              paddingInlineStart={containerDisplay === "block" ? 4 : 0}>
          <Heading as="h2" fontSize="xl" marginBlock="2" paddingInlineStart={containerDisplay === "block" ? 0 : 4}>
            {title}
          </Heading>
          <CustomHeaderComponent questionnaireId={questionnaireId} {...customHeaderProps ?? null} />
        </Flex> :
        <Heading as="h2" fontSize="xl" marginBlock="2" paddingInlineStart="4">
          {title}
        </Heading>
      }

      <Flex
        flexDir="column"
        blockSize="full"
        overflowY="hidden"
        paddingInline="4"
      >
        {children}
        {!isPreview &&
          <CategoryNavigation
            shouldShowNext={shouldShowNext}
            shouldShowPrev={shouldShowPrev}
            currentIndex={currentIndex}
            formId={formId}
            categories={categories}
          />
        }
      </Flex>
    </Flex>
  );
}

export default Category;
